<template>
    <b-modal ref="modal" :visible="visible" no-close-on-backdrop no-close-on-esc modal-class="pdf-modal">
        <div slot="modal-header" class="w-100">
          <div v-if="isFaceSheet === true">
            <h5>{{ title }}
              <button v-if="visit && visit.visitState === 'CheckedIn'" @click.prevent="toggleProcessed(visit)" class="btn btn-orange float-right">
                <font-awesome-icon class="mr-2" :icon="['far', 'check-double']"/>Close and Mark Done
              </button>
              <button type="button" class="btn btn-outline-orange mr-2 float-right" @click.prevent="closeModal()">Close</button>
            </h5>
            </div>
              <div v-if="!isFaceSheet === true">
                <h5>{{ title }}
                  <button type="button" class="close" @click.prevent="closeModal()">
                  <span aria-hidden="true">&times;</span>
                </button>
                </h5>
              </div>
        </div>
        <div class="iframe-container" ref="container">
        <iframe ref="iframe" :src="url" class="pdf-iframe w-100 h-100" type="application/pdf"></iframe>
        </div>
        <div slot="modal-footer" class="w-100"></div>
    </b-modal>
</template>

<script>
  import api from '@/services/api'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'PdfViewModal',

    mixins: [AnalyticsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      title: {
        type: String,
        required: true
      },

      url: {
        type: String,
        required: true
      },

      isFaceSheet: {
        type: Boolean,
        default: false
      },

      visit: {
        type: Object,
        required: false
      }
    },

    data () {
      return {
      }
    },

    methods: {
      closeModal () {
        this.$emit('update:visible', false)
      },
      toggleProcessed (visit) {
        this.showingLoadingModal = true

        api.post('/Dashboard/SetProcessed/' + visit.visitId + '/' + (visit.status === 'Processed' ? 'false' : 'true')).then(response => {
          this.trackEvent('Visit', 'SetProcessed', 'ResponseTime', response.config.requestDuration)
          this.trackEvent('Visit', 'SetProcessed', visit.skipInsurance ? 'false' : 'true', visit.visitId)
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('Visit', 'SetProcessedError', error.message)
            this.$log.error('Error toggling processed status: ' + error.message, error)
            this.errors = ['Error updating processed status: ' + error.message]
          }
        }).then(() => {
          // Workaround for https://github.com/bootstrap-vue/bootstrap-vue/issues/1826
          setTimeout(() => {
            this.showingLoadingModal = false
          }, 100)
          this.closeModal()
          this.$emit('updated')
        })
      }
    }
  }
</script>

<style>
    .pdf-modal .modal-dialog {
        position: absolute;
        top: 20px;
        bottom: 20px;
        left: 20px;
        right: 20px;
        max-width: none;
        margin: 0px;
        max-height: 100%;
    }

    .pdf-modal .modal-dialog .modal-content {
        height: 100%;
    }

    .pdf-modal .modal-dialog .modal-body {
        height: 90%;
    }

    .pdf-iframe {
        height: 95%;
        width: 100%
    }

    .iframe-container {
        height: 100%;
        width: 100%;
        max-height: 100%;
    }
</style>
